import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { connect } from 'react-redux';
import { resetSelectedCols } from 'views/ReportSetup/flow/actions';
import { GroupsZone, OthersZone, AggregatesZone } from '../components/index';

const propTypes = {
};

class ReportTableSetup extends Component {
  componentWillUnmount() {
    const { resetSelectedCols } = this.props;
    resetSelectedCols();
  }

  render() {
    return (
      <Row gutter={16}>
        <Col xs={24} sm={3}>
          <GroupsZone />
        </Col>
        <Col xs={24} sm={12}>
          <OthersZone />
        </Col>
        <Col xs={24} sm={9}>
          <AggregatesZone />
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = ({ global }) => ({
  lang: global.language,
});

const mapDispatchToProps = {
  resetSelectedCols
};

ReportTableSetup.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(ReportTableSetup);



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/container/index.jsx